import React from 'react';
export function Test2Page() {
  return <div className="flex justify-center items-start min-h-screen bg-white p-8" data-id="element-123">
      <h1 className="text-2xl font-semibold" data-id="element-124">
        this is a new page with a different page path
      </h1>
    </div>;
}